import * as React from "react";
import { Card, Dropdown, Form, OverlayTrigger, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import ContentWrapper from "../../layout/components/content-wrapper/content-wrapper.component";
import SubHeader from "../../layout/components/sub-header/sub-header.component";
import { LogicalOperator, OrganizationType, UserActivityLevel, UserResultModel, UsersClient, UsersTagResponseModel, UserTagResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import UserDetailsModal from "./user-details-modal/user-details-modal.component";
import LoadingService from "../../components/loading-indicator/loading-indicator.service";
import { EmailWithLinkToDomain } from "../../components/email-with-link-to-domain/email-with-link-to-domain.component";
import ReactPaginate from "react-paginate";
import { UtcTimePopover } from "../screenshots/screenshots.component";
import ConsumerDomainsModal from "./consumer-domains-modal.component";
import { TargetProcessLink } from "../../components/target-process-link/target-process-link.component";
import CreateMotherTicketModal from "./create-mother-ticket-modal.component";
import { CreateMotherTicketButton } from "./create-mother-ticket-button.component";
import "./users-table-with-caching.styless.scss";

import { DateTimeDisplayUTC } from "../../components/date-time-display/date-time-display-utc.component";
import { TestUsersModal } from "./test-users-modal.component";
import DatePicker from "react-datepicker";
import { addDays } from "../../utilities/date.utilities";
import { UserActivityLevelBadge } from "./user-activity-level-badge.component";
import { UserActivityLevelSelect } from "./user-activity-level-select/user-activity-level-select.component";
import UserTagsModal from "./user-tags-modal.component";
import UserTagPicker, { TagOption, UserTagPickerType } from "../../components/user-tag-picker/user-tag-picker.component";
import { TagResponseModel } from "../../swagger-clients/dashboard-clients.service";
import { UserTagFilter, UserTagFilterType } from "../../components/user-tag-filter/user-tag-filter.component";
import queryString from "query-string";
import { RouteComponentProps, withRouter } from "react-router-dom";
import BootstrapTooltip from "../../components/bootstrap-tooltip/bootstrap-tooltip";
import { getUserTagsClient } from "../../services/api-clients.service";
import { _copyAndSort } from "../../utilities/array.helpers";
import SystemUserTagCodes from "./users.shared";
import { DateTimeDisplay } from "../../components/date-time-display/date-time-display.component";
import { ShowErrorFromResponse } from "../../utilities/response-processor";
import { spawn } from "child_process";
import PermissionGuard from "../../auth/PermissionGuard";
import { UserRole } from "../../auth/user-roles";
import AuthContext from "../../auth/AuthContext";


type IUserTableWithCachingProps = RouteComponentProps & {

}

type IUsersQueryParameters = {
    searchTerm: string;
    motherTicketId?: number;
    createdFromDate?: Date;
    createdToDate?: Date;
    includeUserTags?: number[];
    includeOperator?: LogicalOperator;
    excludeUserTags?: number[];
    excludeOperator?: LogicalOperator;
    orderby?: string;
    orderByDescending: boolean;
    showByActivity: UserActivityLevel[];
    currentPage: number;
    recordsPerPage: number;
}

type IUserTableState = {
    filters: IUsersQueryParameters,
    totalRecords: number;
    users: UserResultModel[];
    isDataLoaded: boolean;
    showDetailsModal: boolean;
    selectedUser?: UserResultModel;
    showConsumerDomainsModal: boolean;
    showUserTagsModal: boolean;
    showTestUsersModal: boolean;
    showCreateMotherTicketModal: boolean;
    loadingLinkedInProfile: { [userId: string]: boolean }
}



const getTodayDate = () => {
    let dateNow = new Date();
    dateNow.setHours(0);
    dateNow.setMinutes(0);
    dateNow.setSeconds(0);
    dateNow.setMilliseconds(0);
    return dateNow;
}

const getDefaultStartDate = () => {

    return addDays(getTodayDate(), -30);
}


const getDefaultEndDate = () => {
    let tomorrow = addDays(new Date(), 1);
    tomorrow.setHours(0);
    tomorrow.setMinutes(0);
    tomorrow.setSeconds(0);
    tomorrow.setMilliseconds(0);
    return tomorrow;

}

const ARRAY_PROPERTIES = ['includeUserTags', 'excludeUserTags'];

const getDefaultFilter = () => {
    return {
        searchTerm: "",
        motherTicketId: undefined,
        createdFromDate: undefined,
        createdToDate: undefined,
        hideConsumers: false,
        hideTestUsers: true,
        hideUsersWithMotherTicket: false,
        orderby: "createdDateTime",
        orderByDescending: true,
        showByActivity: [],
        includeUserTags: [],
        includeOperator: LogicalOperator.And,
        excludeUserTags: [],
        excludeOperator: LogicalOperator.Or,
        currentPage: 1,
        recordsPerPage: 50,
    } as IUsersQueryParameters;
}


const getAllUserTags = async () => {
    try {
        const client = getUserTagsClient();
        const userTagsResp = await client.getUserTags(null, null, undefined, 0, 10000);
        const sortedMappedOptions = _copyAndSort<UserTagResponseModel>(userTagsResp.items, "name", false);
        return sortedMappedOptions;

    } catch (error) {
        console.log("An error occurred while loading user tags", error);
    }

}



class UserTableWithCaching extends React.Component<IUserTableWithCachingProps, IUserTableState> {

    tagPickerRef: React.MutableRefObject<UserTagPickerType | null>;
    includeTagsFilterRef: React.MutableRefObject<UserTagFilterType | null>;
    excludeTagsFilterRef: React.MutableRefObject<UserTagFilterType | null>;

    constructor(props: IUserTableWithCachingProps) {
        super(props);
        this.tagPickerRef = React.createRef<UserTagPickerType>();
        this.includeTagsFilterRef = React.createRef<UserTagFilterType>();
        this.excludeTagsFilterRef = React.createRef<UserTagFilterType>();

        const defaultFilters = getDefaultFilter();
        const filters: IUsersQueryParameters = this.getFiltersFromQueryParams(defaultFilters);
        console.log("filters from query", filters);
        this.state = {
            filters: filters,
            totalRecords: 0,
            users: [],
            isDataLoaded: false,
            showDetailsModal: false,
            showConsumerDomainsModal: false,
            showUserTagsModal: false,
            showTestUsersModal: false,
            showCreateMotherTicketModal: false,
            showZoomUmParticipantsSync: false,
            loadingLinkedInProfile: {}
        } as IUserTableState;
    }

    getFiltersFromQueryParams(defaultValues: IUsersQueryParameters) {
        const params: IUsersQueryParameters = queryString.parse(this.props.location.search, {
            parseNumbers: true,
            parseBooleans: true,
        }) as any;

        const filters = { ...defaultValues };

        for (let k of Object.keys(params)) {
            if (ARRAY_PROPERTIES.includes(k)) {
                // Ensure the property is an array
                (filters as any)[k] = Array.isArray((params as any)[k]) ? (params as any)[k] : [(params as any)[k]];
            } else {
                (filters as any)[k] = (params as any)[k];
            }
        }

        return filters;
    }


    async componentDidMount() {

        if (!this.props.location.search) {
            const allUserTags = await getAllUserTags();
            const testUserTag = allUserTags?.find(x => x.code == SystemUserTagCodes.TEST_USER);
            let includeTags: number[] = [];
            const companyUserTag = allUserTags?.find(x => x.code == SystemUserTagCodes.COMPANY);
            if (!!companyUserTag) {
                includeTags.push(companyUserTag.id);
            }
            let excludeTags: number[] = !!testUserTag ? [testUserTag.id] : [];
            const consumerUserTag = allUserTags?.find(x => x.code == SystemUserTagCodes.CONSUMER);
            if (!!consumerUserTag) {
                excludeTags.push(consumerUserTag.id);
            }

            this.setState(s => ({ ...s, filters: { ...s.filters, includeUserTags: includeTags, excludeUserTags: excludeTags } }), async () => {
                await this.getUsers();
            });
        } else {
            await this.getUsers();
        }



    }

    async componentDidUpdate(prevProps: Readonly<IUserTableWithCachingProps>, prevState: Readonly<IUserTableState>, snapshot?: any) {
        if (prevState.filters.recordsPerPage !== this.state.filters.recordsPerPage ||
            prevState.filters.currentPage !== this.state.filters.currentPage) {
            await this.getUsers();
        }
    }

    updateUrl = () => {
        const { history } = this.props;
        const queryParams = this.getQueryString(this.state.filters, getDefaultFilter());
        history.replace(`?${queryParams}`);
    };

    getQueryString = (filters: IUsersQueryParameters, defaultValues: IUsersQueryParameters) => {
        let clone: IUsersQueryParameters = { ...filters };

        for (let k of Object.keys(clone)) {
            if ((clone as any)[k] == (defaultValues as any)[k])
                delete (clone as any)[k];
        }

        // Hack 
        if (!!clone.createdToDate)
            clone.createdToDate = clone.createdToDate.toISOString() as any;
        if (!!clone.createdFromDate)
            clone.createdFromDate = clone.createdFromDate.toISOString() as any;

        const queryParams = queryString.stringify(clone as any, {
            skipNull: true,
            skipEmptyString: true
        });

        return queryParams;
    }

    async getUsers() {
        try {
            this.updateUrl();
            LoadingService.showLoading();
            this.setState({ isDataLoaded: false });
            const { searchTerm, orderByDescending, orderby, createdFromDate, createdToDate, showByActivity, includeUserTags, includeOperator, excludeUserTags,
                excludeOperator, recordsPerPage, currentPage, motherTicketId } = this.state.filters;
            const client = new UsersClient(process.env.REACT_APP_BASE_URL);

            const createdFromDateUtc = createdFromDate ? new Date(Date.UTC(createdFromDate.getFullYear(), createdFromDate.getMonth(), createdFromDate.getDate(), createdFromDate.getHours(), createdFromDate.getMinutes(), createdFromDate.getSeconds())) : null;
            const createdToDateUtc = createdToDate ? new Date(Date.UTC(createdToDate.getFullYear(), createdToDate.getMonth(), createdToDate.getDate(), createdToDate.getHours(), createdToDate.getMinutes(), createdToDate.getSeconds())) : undefined;



            const usersResp = await client.getCachedUsers((currentPage - 1) * recordsPerPage, recordsPerPage,
                includeUserTags, includeOperator, excludeUserTags, excludeOperator, createdFromDateUtc, createdToDateUtc, searchTerm, motherTicketId, showByActivity,
                orderby, orderByDescending);

            this.setState(s => ({ ...s, totalRecords: usersResp.totalRecords, users: [...usersResp.items] }), () => { console.log("State after", this.state) });

        } catch (error) {
            console.log("An error occurred while loading users.", error);
            toast.error("An error occurred while loading users.");
        } finally {
            this.setState({ isDataLoaded: true });
            LoadingService.hideLoading();
        }
    }





    updateFilters(...functions: ((f: IUsersQueryParameters) => void)[]) {
        let clone = { ...this.state.filters };
        functions.forEach(func => {
            func(clone);
        });
        this.setState(s => ({ ...s, filters: { ...clone } }));
    }

    async onColumnClick(column: string) {
        const { orderby, orderByDescending } = this.state.filters;
        if (orderby == column) {
            this.setState(s => ({ filters: { ...s.filters, orderByDescending: !s.filters.orderByDescending } }), async () => { await this.getUsers(); });
        } else {
            this.setState(s => ({ filters: { ...s.filters, orderby: column, orderByDescending: true } }), async () => { await this.getUsers(); });
        }
    }

    getSortValue = (columnName: string) => {
        const { orderByDescending, orderby } = this.state.filters;
        if (orderby == columnName) {
            if (orderByDescending) {
                return "desc";
            } else {
                return "asc";
            }
        }
        return undefined;
    }

    SetCurrentPage = (page: number) => {
        console.log("SetCurrentPage", page);
        //this.setState(s => ({ ...s, currentPage: page }));
        this.updateFilters(f => f.currentPage = page);
    }

    onMotherTicketCreated = (motherTicketId: number, userId: string) => {

        const { users } = this.state;
        const updatedUsers = users.map((user) => {
            if (user.id == userId) {
                // return { ...user, targetProcesMotherTicketIds: [...(user.targetProcesMotherTicketIds ?? []), motherTicketId] } as UserResultModel;
            }
            return user;
        });
        this.setState({ users: [...updatedUsers], showCreateMotherTicketModal: false });
    }

    setDate(dateFrom?: Date, dateTo?: Date) {
        const fromDate = dateFrom != null && !!dateFrom ? new Date(Date.parse(dateFrom.toString())) : undefined;
        const toDate = dateTo != null && !!dateTo ? new Date(Date.parse(dateTo.toString())) : undefined;
        this.updateFilters(f => f.createdToDate = toDate, f => f.createdFromDate = fromDate);
    }

    setToDate(date?: Date) {
        const toDate = date != null && !!date ? new Date(Date.parse(date.toString())) : undefined;
        this.updateFilters(f => f.createdToDate = toDate);
    }
    setFromDate(date?: Date) {
        const fromDate = date != null && !!date ? new Date(Date.parse(date.toString())) : undefined;
        console.log("UpdateFilters setFromDate,", fromDate);
        this.updateFilters(f => f.createdFromDate = fromDate);
    }

    onTodayClick = () => {
        this.setDate(getTodayDate(), getDefaultEndDate());

    }
    onLast7DaysClick = () => {
        const startDate = addDays(getTodayDate(), -7);
        this.setDate(startDate, getDefaultEndDate());

    }
    onLast30DaysClick = () => {
        const startDate = addDays(getTodayDate(), -30);
        this.setDate(startDate, getDefaultEndDate());

    }

    onLastMonthClick = () => {
        const dateNow = new Date();
        const firstInMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1, 0, 0, 0);
        let firstInNextMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1, 0, 0, 0);
        firstInNextMonth.setMonth(firstInMonth.getMonth() + 1);
        const lastDayOfMonth = addDays(firstInNextMonth, -1);
        this.setDate(firstInMonth, lastDayOfMonth);

    }

    onLastYearClick = () => {
        const dateNow = new Date();
        const januaryFirst = new Date(dateNow.getFullYear(), 0, 1, 0, 0, 0);
        this.setDate(januaryFirst, getDefaultEndDate());

    }

    onAddDayClick = (numberOfDays: number) => {
        const { createdFromDate } = this.state.filters;
        const newDate = addDays(createdFromDate ?? new Date(), numberOfDays);
        this.setFromDate(newDate);
    }
    onAddMonthClick = (numberOfMonths: number) => {
        const { createdFromDate } = this.state.filters;
        let newDate = createdFromDate ?? new Date();
        newDate.setMonth(newDate.getMonth() + numberOfMonths);
        this.setFromDate(newDate);
    }

    onUserTagsChanged = (userId: string, tags: TagOption[]) => {
        const updatedUsers = this.state.users.map(x => {
            if (x.id == userId) {
                const mappedTags = tags?.map(tag => new UsersTagResponseModel({ userTagId: +tag.value, name: tag.label, isSystemTag: tag.isSystemTag, color: tag.color })) ?? [];
                return new UserResultModel({ ...x, tags: mappedTags });
            }
            return x;
        });
        this.setState(s => ({ ...s, users: updatedUsers }));

    }

    motherTicketHasTag = (user: UserResultModel, tag: string) => {
        return user.motherTicket?.tags?.find(x => x.name.toLowerCase() == tag) !== undefined;
    }

    onScrenshotImageClick = (ev: any, user: UserResultModel) => {
        ev.preventDefault();
        const userQuery = `userId=${user.id}`;
        const url = `/screenshots?${userQuery}&fromDate=${user.createdAt.toISOString()}`;
        this.props.history.push(url);
    }
    getScreenshotsLink = (user: UserResultModel) => {
        const userQuery = `userId=${user.id}`;
        const url = `${window.location.origin}/screenshots?${userQuery}&fromDate=${user.createdAt.toISOString()}`;
        return url;
    }

    onSearchForLinkedInProfile = async (userId: string) => {
        try {
            this.setState(s => ({ ...s, loadingLinkedInProfile: { ...s.loadingLinkedInProfile, [userId]: true } }));
            const client = new UsersClient(process.env.REACT_APP_BASE_URL);
            const linkedInProfileResp = await client.getLinkedInUrl(userId);
            if (!!linkedInProfileResp.url) {
                const { users } = this.state;
                const updatedUsers = users.map(x => {
                    if (x.id == userId) {
                        return { ...x, linkedInUrl: linkedInProfileResp.url } as UserResultModel
                    }
                    return x;
                });

                this.setState(s => ({ ...s, users: updatedUsers }));
            } else {
                toast.info("User LinkedIn url not found.");
            }


        } catch (error) {
            ShowErrorFromResponse(error, "An error occurred while searching for LinkedIn profile of user.");
        } finally {
            this.setState(s => ({ ...s, loadingLinkedInProfile: { ...s.loadingLinkedInProfile, [userId]: false } }));
        }
    }


    render() {

        const { searchTerm, motherTicketId,
            showByActivity, includeUserTags, includeOperator, excludeUserTags, excludeOperator,
            recordsPerPage, currentPage,
            createdFromDate, createdToDate } = this.state.filters;

        const { users, isDataLoaded, showDetailsModal, selectedUser, showConsumerDomainsModal, showUserTagsModal, showTestUsersModal, totalRecords,
            showCreateMotherTicketModal, loadingLinkedInProfile } = this.state;

        const totalPages = Math.ceil(totalRecords / recordsPerPage);
        //  console.log("totalPages,totalRecords,recordsPerPage", totalPages, totalRecords, recordsPerPage);

        const leftHeaderItems = [
            <button type="button" className="btn btn-primary btn-sm ml-2"
                onClick={() => { this.setState(s => ({ ...s, showConsumerDomainsModal: true })) }} >
                Consumer domains
            </button>,
            <button type="button" className="btn btn-primary btn-sm ml-2"
                onClick={() => { this.setState(s => ({ ...s, showTestUsersModal: true })) }} >
                Test users
            </button>,
            <button type="button" className="btn btn-primary btn-sm ml-2"
                onClick={() => { this.setState(s => ({ ...s, showUserTagsModal: true })) }} >
                Tags
            </button>
        ];





        return [
            <AuthContext.Consumer>
                {(auth) => {
                    if (!auth) return null;

                    const { user, isLoggedIn, isInRole } = auth;
                    return <> <SubHeader key="sub-header" title="Users" leftItems={isInRole([UserRole.Admin]) ? leftHeaderItems : []} rightItems={[]} />
                        <ContentWrapper key="content-wrapper" className="pl-4 pr-4">
                            <Card className='mb-4' style={{ marginRight: "auto", marginLeft: "auto", width: "100%" }}>
                                <div className="pt-3 pl-3 pr-3 mr-3 d-flex">
                                    <form onSubmit={(ev) => { ev.preventDefault(); if (currentPage !== 1) { this.SetCurrentPage(1); } else { this.getUsers(); } }} action="">
                                        <div className="form-row align-items-center">
                                            <div className="col-auto" style={{ minWidth: "330px" }}>
                                                <input type="text"
                                                    name="searchTerm"
                                                    className="form-control mb-2"
                                                    onChange={e => this.updateFilters(f => f.searchTerm = e.target.value)}
                                                    placeholder="Display name or User principal name or Email" value={searchTerm} />
                                            </div>

                                            <div className="col-auto" style={{ width: "150px" }}>
                                                <input type="text"
                                                    name="motherTicketId"
                                                    className="form-control mb-2"
                                                    onChange={e => this.updateFilters(f => f.motherTicketId = !!e.target.value ? +e.target.value : undefined)}
                                                    placeholder="Mother ticket Id" value={motherTicketId} />
                                            </div>
                                            <div className="input-group mr-2 mb-2" style={{ width: '380px' }}>
                                                <span className="input-group-text"><i className="far fa-calendar-alt"></i></span>
                                                <div className="input-group__datepicker-wrapper">
                                                    <DatePicker
                                                        id="fromDate"
                                                        className="form-control"
                                                        selected={createdFromDate}
                                                        onChange={(date: Date) => {
                                                            if (!date) { this.setFromDate(undefined); }
                                                            else
                                                                this.setFromDate(date);
                                                        }}
                                                        showTimeSelect
                                                        maxDate={createdToDate}
                                                        placeholderText="Created from"
                                                        dateFormat="dd-MM-yyyy HH:mm"
                                                        timeFormat="HH:mm"
                                                        autoComplete="off" />
                                                </div>
                                                <span className="input-group-text">-</span>

                                                <div className="input-group__datepicker-wrapper">
                                                    <DatePicker
                                                        id="toDate"
                                                        className="form-control"
                                                        selected={createdToDate}
                                                        onChange={(date: Date) => {
                                                            if (!date) { this.setToDate(undefined); }
                                                            else
                                                                this.setToDate(date);
                                                        }}
                                                        showTimeSelect
                                                        maxDate={addDays(new Date(), 1)}
                                                        placeholderText="Created to"
                                                        dateFormat="dd-MM-yyyy HH:mm"
                                                        timeFormat="HH:mm"
                                                        autoComplete="off" />
                                                </div>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="primary" className="datePickerWithDropdown" id="dropdown-basic" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={this.onTodayClick} >Today</Dropdown.Item>
                                                        <Dropdown.Item onClick={this.onLast7DaysClick}>Last 7 days</Dropdown.Item>
                                                        <Dropdown.Item onClick={this.onLast30DaysClick}>Last 30 days</Dropdown.Item>
                                                        <Dropdown.Item onClick={this.onLastMonthClick}>This month</Dropdown.Item>
                                                        <Dropdown.Item onClick={this.onLastYearClick}>This year</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => { this.onAddDayClick(1) }}>+ day</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => { this.onAddDayClick(-1) }}>- day</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => { this.onAddMonthClick(1) }}>+ month</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => { this.onAddMonthClick(-1) }}>- month</Dropdown.Item>

                                                    </Dropdown.Menu>
                                                </Dropdown>


                                            </div>


                                            <div className="col-auto mr-2" style={{ minWidth: "250px" }}>
                                                <UserActivityLevelSelect
                                                    values={showByActivity}
                                                    className="mb-2"
                                                    placeholder="Show by activity"
                                                    onChange={data => this.updateFilters(f => f.showByActivity = (data as any) ?? [])} />
                                            </div>
                                            <PermissionGuard allowedRoles={[UserRole.Sales]}>
                                                <div className="col-auto pl-0">
                                                    <button type="submit" className="btn btn-primary mb-2" >Search</button>
                                                </div>
                                            </PermissionGuard>
                                        </div>
                                        <PermissionGuard allowedRoles={[UserRole.Admin]}>
                                            <div className="row">
                                                <div className="col-auto pr-2" style={{ minWidth: "400px" }}>
                                                    <UserTagFilter
                                                        icon="fas fa-check"
                                                        iconColor="green"
                                                        logicalOperator={includeOperator}
                                                        values={includeUserTags}
                                                        ref={this.includeTagsFilterRef}
                                                        className="mb-2"
                                                        placeholder={"Include tags"}
                                                        onOperatorChange={(operator) => { this.updateFilters(f => f.includeOperator = operator); }}
                                                        onChange={(newValues) => {
                                                            const values: number[] | undefined = newValues !== undefined && newValues !== null ? newValues.map(x => +x.value) : undefined;
                                                            this.updateFilters(f => f.includeUserTags = values);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-auto pl-0 pr-2" style={{ minWidth: "400px" }}>
                                                    <UserTagFilter
                                                        icon="fas fa-times"
                                                        iconColor="red"
                                                        logicalOperator={excludeOperator}
                                                        values={excludeUserTags}
                                                        ref={this.excludeTagsFilterRef}
                                                        className="mb-2"
                                                        placeholder={"Exclude tags"}
                                                        onOperatorChange={(operator) => { this.updateFilters(f => f.excludeOperator = operator); }}
                                                        onChange={(newValues) => {
                                                            const values: number[] | undefined = newValues !== undefined && newValues !== null ? newValues.map(x => +x.value) : undefined;
                                                            this.updateFilters(f => f.excludeUserTags = values);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-auto pl-0">
                                                    <button type="submit" className="btn btn-primary mb-2" >Search</button>
                                                </div>
                                            </div>
                                        </PermissionGuard>




                                    </form>

                                    <div className="mr-3"
                                        style={{
                                            marginLeft: 'auto',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            alignSelf: "flex-start",
                                            textAlign: "center",
                                            gap: "2px"
                                        }}>
                                        <b style={{ fontSize: '1.5em', lineHeight: '1em' }}>{totalRecords}</b>
                                        <span style={{ fontSize: '0.8em', lineHeight: '0.8em' }}>Total records</span>
                                    </div>
                                    <div style={{ minWidth: "75px" }}>
                                        <select
                                            className="form-control form-select"
                                            value={recordsPerPage}
                                            onChange={(event) => this.setState(s => ({ filters: { ...s.filters, recordsPerPage: +event.target.value } }))}>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                        </select>
                                    </div>

                                </div>
                            </Card >
                            <Card >
                                <Card.Body>

                                    <div className="">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th
                                                        className={"sortable " + this.getSortValue("displayName")}
                                                        onClick={() => { this.onColumnClick.call(this, "displayName") }}
                                                    >Display name</th>

                                                    <th className={"sortable " + this.getSortValue("email")}
                                                        onClick={() => { this.onColumnClick.call(this, "email") }}>Email</th>
                                                    <th className="text-center">LinkedIn</th>
                                                    <th className="text-center">Organization</th>
                                                    <PermissionGuard allowedRoles={[UserRole.Admin]}>
                                                        <th className={"text-center sortable " + this.getSortValue("screenshotsCount")}
                                                            onClick={() => { this.onColumnClick.call(this, "screenshotsCount") }}>Screenshots</th>
                                                    </PermissionGuard>


                                                    <th style={{ minWidth: '100px' }}>Tags</th>
                                                    <th className={"text-center sortable " + this.getSortValue("createdDateTime")}
                                                        onClick={() => { this.onColumnClick.call(this, "createdDateTime") }}
                                                    >Created at</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                                {users.map((user) =>
                                                (<tr className="users-table-row" key={`${user.id}-${user.userPrincipalName}`}
                                                    onClick={() => { this.setState({ showDetailsModal: true, selectedUser: user }) }}>
                                                    <td className="align-middle"><UserActivityLevelBadge userActivityLevel={user.activityLevel} /></td>
                                                    <td className="align-middle">
                                                        <span className="align-middle d-flex flex-column" style={{ lineHeight: "13px" }}>
                                                            {user.displayName}
                                                            <small>{user.userPrincipalName} </small>
                                                        </span>

                                                    </td>
                                                    <td className="align-middle"><EmailWithLinkToDomain email={user.email} />


                                                        {this.motherTicketHasTag(user, "university") && <BootstrapTooltip tooltipText="University"><span style={{ marginLeft: "3px" }}><i className="fas fa-graduation-cap" style={{ color: "black" }}></i></span></BootstrapTooltip>}
                                                        {this.motherTicketHasTag(user, "consulting") && <BootstrapTooltip tooltipText="Consulting"><span style={{ marginLeft: "3px" }}><i className="bi bi-briefcase" style={{ color: "black" }}></i></span></BootstrapTooltip>}
                                                    </td>
                                                    <td className="align-middle text-center">
                                                        {!loadingLinkedInProfile[user.id] && !!user.linkedInUrl && <a href={`${user.linkedInUrl}`} target="_blank"
                                                            onClick={(ev) => ev.stopPropagation()}><i className="fab fa-linkedin fa-lg"></i></a>}
                                                        {!loadingLinkedInProfile[user.id] && !!user.motherTicket && !user.linkedInUrl &&
                                                            <button
                                                                className="btn btn-sm  btn-outline-secondary d-flex"
                                                                onClick={(ev) => { ev.preventDefault(); ev.stopPropagation(); this.onSearchForLinkedInProfile(user.id!) }}
                                                            >
                                                                <i className="bi bi-search"></i> LinkedIn
                                                            </button>}
                                                        {!!loadingLinkedInProfile[user.id] && <div>
                                                            <Spinner animation="border" size="sm" variant="info" className="mr-2" /><span className="m-0">Loading...</span>
                                                        </div>}
                                                    </td>
                                                    <td className="align-middle text-center">
                                                        {!!user.motherTicket &&
                                                            <TargetProcessLink targetProcesMotherTicketId={user.motherTicket.id} totalUsersCount={user.motherTicket.numberOfUsers} />

                                                        }
                                                        <PermissionGuard allowedRoles={[UserRole.Admin]}>
                                                            {!user.motherTicket &&
                                                                <CreateMotherTicketButton className="mother-ticket-button" onClick={() => { this.setState({ selectedUser: user, showCreateMotherTicketModal: true }) }} />}
                                                        </PermissionGuard>
                                                    </td>
                                                    <PermissionGuard allowedRoles={[UserRole.Admin]}>
                                                        <td className="align-middle text-center">
                                                            {!!user?.screenshotsCount && <a href={this.getScreenshotsLink(user)}>{user.screenshotsCount}</a>}
                                                        </td>
                                                    </PermissionGuard>


                                                    <td onClick={(ev) => { ev.stopPropagation(); ev.preventDefault(); }}>
                                                        <UserTagPicker ref={this.tagPickerRef} userId={user.id!} tags={user.tags ?? []}
                                                            onTagsChanged={(tags) => { this.onUserTagsChanged(user.id!, tags) }}
                                                            onTagCreated={() => {

                                                                this.includeTagsFilterRef?.current?.GetOptions();
                                                                this.excludeTagsFilterRef?.current?.GetOptions();
                                                                this.tagPickerRef?.current?.getSuggestions();
                                                            }}
                                                        />

                                                    </td>
                                                    <td className="align-middle text-center">
                                                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={UtcTimePopover}>
                                                            <span><DateTimeDisplay date={user.createdAt} /></span>
                                                        </OverlayTrigger>
                                                    </td>
                                                </tr>))
                                                }

                                                {!isDataLoaded &&
                                                    <tr>
                                                        <td colSpan={10} className="text-center">Loading...</td>
                                                    </tr>
                                                }


                                            </tbody>
                                        </table>

                                        {totalPages > 1 &&
                                            <div className="d-flex align-items-center">
                                                <ReactPaginate
                                                    previousLabel={'previous'}
                                                    nextLabel={'next'}
                                                    breakLabel={'...'}
                                                    breakClassName={'break-me page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={4}
                                                    pageRangeDisplayed={10}
                                                    previousClassName={'page-item'}
                                                    previousLinkClassName={'page-link'}
                                                    nextClassName={'page-item'}
                                                    nextLinkClassName={'page-link'}
                                                    forcePage={currentPage - 1}
                                                    onPageChange={(page: any) => {
                                                        console.log("Selected page:", page);
                                                        this.SetCurrentPage(page.selected + 1);
                                                        document.body.scrollTop = 0; // For Safari
                                                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                                                    }}
                                                    containerClassName={'pagination mb-0'}
                                                    activeClassName={'active'}
                                                />

                                            </div>
                                        }
                                    </div>

                                    {showDetailsModal && <UserDetailsModal
                                        show={true}
                                        userId={selectedUser?.id ?? ""}
                                        userDisplayName={selectedUser?.displayName ?? ""}
                                        userPrincipalName={selectedUser?.userPrincipalName ?? ""}
                                        onMotherTicketChanged={this.onMotherTicketCreated}
                                        onReloadUsers={() => { this.setState({ showDetailsModal: false, selectedUser: undefined }, () => { this.getUsers(); }); }}
                                        onHide={() => this.setState({ showDetailsModal: false, selectedUser: undefined })} />
                                    }

                                    {showConsumerDomainsModal &&
                                        <ConsumerDomainsModal show={true} onHide={() => this.setState(s => ({ ...s, showConsumerDomainsModal: false }))} />}

                                    <UserTagsModal show={showUserTagsModal}
                                        onHide={() => this.setState(s => ({ ...s, showUserTagsModal: false }))}
                                        onTagsChanged={() => {

                                            this.includeTagsFilterRef?.current?.GetOptions();
                                            this.excludeTagsFilterRef?.current?.GetOptions();
                                            this.tagPickerRef?.current?.getSuggestions();
                                        }}
                                    />

                                    {showTestUsersModal &&
                                        <TestUsersModal show={true} onHide={() => this.setState(s => ({ ...s, showTestUsersModal: false }))} />}

                                    {showCreateMotherTicketModal && selectedUser &&
                                        <CreateMotherTicketModal
                                            show={true}
                                            user={selectedUser}
                                            onSuccess={(motherTicketId) => this.onMotherTicketCreated(motherTicketId, selectedUser.id!)}
                                            onHide={() => { this.setState(s => ({ ...s, showCreateMotherTicketModal: false })) }}

                                        />}


                                </Card.Body>
                            </Card>
                        </ContentWrapper></>
                }}
            </AuthContext.Consumer>];
    }
}



export default withRouter(UserTableWithCaching);